import { useCallback } from "react";

import type { SiteControllerSettingBaseFormModelOnSetViewModelType } from "../../../../base/use-case/use-create-model/use-create-model";
import type { SiteControllerSettingTemairazuFormModel } from "../../../type";

type Props = {
	viewModel: SiteControllerSettingTemairazuFormModel["ViewModel"];
	onSetViewModel: SiteControllerSettingBaseFormModelOnSetViewModelType;
};

export type SiteControllerSettingTemairazuFormModelMethodsType = {
	siteControllerSettingNeppanFormModelMethods: {
		onSetPassword: (value: string) => void;
		onSetSetUpRoomPriceByChillnn: (value: boolean) => void;
	};
};

type UseSiteControllerSettingTemairazuFormModelMethodsType = ({
	viewModel,
	onSetViewModel,
}: Props) => SiteControllerSettingTemairazuFormModelMethodsType;

export const useSiteControllerSettingTemairazuFormModelMethods: UseSiteControllerSettingTemairazuFormModelMethodsType =
	({ onSetViewModel }) => {
		const onSetPassword = useCallback(
			(value: string) => {
				onSetViewModel([
					{
						key: "password",
						value: {
							isEdited: true,
							value,
						},
					},
				]);
			},
			[onSetViewModel],
		);

		const onSetSetUpRoomPriceByChillnn = useCallback(
			(value: boolean) => {
				onSetViewModel([
					{
						key: "setUpRoomPriceByChillnn",
						value: {
							isEdited: true,
							value,
						},
					},
				]);
			},
			[onSetViewModel],
		);

		return {
			siteControllerSettingNeppanFormModelMethods: {
				onSetPassword, //
				onSetSetUpRoomPriceByChillnn,
			},
		};
	};
